import styled from "styled-components";

export const FooterContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 15rem;
  /* justify-content: space-between; */
  @media (max-width: 1024px) {
    padding-top: 0;
  }
`;
export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 190px;
  margin-bottom: 6rem;
  @media (max-width: 1150px) {
    margin-bottom: 10rem;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    margin-bottom: 0;
  }
`;

export const FooterContent = styled.div`
  width: 38%;
  @media (max-width: 1024px) {
    display: none;
  }
`;
export const LogoContainer = styled.div`
  h2 {
    font-size: 2.4rem;
    font-weight: 900;
    color: var(--footer-color);
    font-family: Peyda;
    margin-bottom: 12px;
  }
  @media (max-width: 1024px) {
    h2 {
      text-align: center;
      margin-top: 6rem;
    }
  }
`;

export const FooterButtom = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0 2.5rem 0;
  border-top: 2.67px solid var(--border-color);
  color: var(--footer-bottom-color);
  font-size: 1.8rem;
  font-weight: 700;
  font-family: Peyda;
  margin-top: 35px;
  a {
    font-size: 2rem;
    color: var(--title-color);
    transition: 0.5s;
    &:hover {
      color: var(--primary-color);
    }
  }
  @media (max-width: 768px) {
    font-size: 1.5rem;
    a {
      font-size: 1.8rem;
    }
  }
  @media (max-width: 600px) {
    font-size: 1rem;
    padding: 1rem 0;
    a {
      font-size: 1rem;
    }
  }
  @media (max-width: 455px) {
    font-size: 1.2rem;
    a {
      font-size: 1rem;
    }
  }
  @media (max-width: 400px) {
    font-size: 1rem;
    a {
      font-size: 1.1rem;
    }
  }
`;

export const FooterNav = styled.ul`
  /* width: 30%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: right;
  li {
    margin-bottom: 2rem;
  }
  li a {
    color: var(--nav-color);
    transition: all 0.4s ease-in-out;
    color: var(--nav-color);
    font-size: 1.6rem;
    font-weight: 500;
    text-align: right;
    font-family: Peyda;
    &:hover {
      opacity: 0.6;
    }
  }
  & li:first-child a {
    color: var(--logo-color);
  }
  @media (max-width: 1024px) {
    height: 200px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const FooterAddress = styled.address`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 250px;
  @media (max-width: 1024px) {
    width: 100%;
    align-items: center;
    text-align: center;
  }
`;
export const FooterAddressItem = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  /* margin-bottom: 3rem; */
  p,
  span {
    width: 100%;
    color: var(--footer-color);
    font-size: 1.6rem;
    font-weight: 400;
    margin-bottom: 1.2rem;
    font-family: "Peyda";
    line-height: 3.2rem;
  }
  a {
    width: 100%;
    color: var(--footer-color);
    font-size: 1.6rem;
    font-weight: 400;
    margin-bottom: 1.2rem;
    font-family: "Peyda";
    line-height: 3.2rem;
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width1024 || "100%"};
    margin-bottom: 1.2rem;
    height: 32px;
  }
  @media (max-width: 600px) {
    height: auto;
    margin-bottom: 0;
    p {
      margin-bottom: 0;
    }
  }
  @media (max-width: 480px) {
    height: auto;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  p {
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 3.2rem;
    font-family: Peyda;
    color: var(--title-color);
    @media (max-width: 1024px) {
      line-height: 2.8rem;
    }
    @media (max-width: 850px) {
      font-size: 1.4rem;
      line-height: 2rem;
    }
  }

  @media (max-width: 1350px) {
    width: 100%;
  }
  @media (max-width: 525px) {
    font-size: 1.6rem;
  }
`;

// export const TextContainer = styled.div`
//   width: ${(props) => props.width};
//   height: ${(props) => props.height};

//   p {
//     font-size: 1.6rem;
//     font-weight: 400;
//     line-height: 3.2rem;
//     font-family: Peyda;
//     color: var(--title-color);
//     @media (max-width: 768px) {
//       font-size: 1.4rem;
//       line-height: 2rem;
//     }
//   }
//   @media (max-width: 600px) {
//     margin-top: 2rem;
//   }
//   @media (max-width: 400px) {
//     width: ${(props) => props.width400};
//   }
//   @media (max-width: 1350px) {
//     width: 100%;
//   }
//   @media (max-width: 525px) {
//     font-size: 1.6rem;
//   }
// `;

export const EnamadContainer = styled.div`
  margin-top: 14px;
  margin-bottom: 20px;
  @media (max-width: 1024px) {
    margin: 0px 0 60px 0;
  }
  @media (max-width: 600px) {
    margin: 0px 0 20px 0;
    & img {
      width: 60px !important;
      height: 60px !important;
    }
  }
`;
